export default function DataListItem({left,right,status}){
    return(
        <div className={"data-list-item"+(status==0?" data-list-item-off":"")}>
            <div className="data-list-item-left">{left}</div>
            {right && <div className="data-list-item-right">{right}</div>}
        </div>
    )
}